// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"errorContent_wrapper__D1HYN","svg":"errorContent_svg__iucAH"};